/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha25 = props => (
  <svg version={1.0} viewBox="0 0 121 122" width="1em" height="1em" {...props}>
    <path d="M47.8 7.6C29.2 12.1 13 28.5 9.1 46.8 7.7 53.4 7.7 65 9.1 71c3.6 15.7 16.8 30.7 32.5 36.9l5.1 2 .6-13.6c.4-7.5.7-20.1.7-28 0-15.4.8-18.6 5.2-21.7 2.9-2.1 10.7-2.1 13.6 0C71.7 50 72 51.9 72 82v28l2.8-.6c6.5-1.6 16.9-7.9 22.8-13.8 28.9-28.9 14.7-78.9-25.2-88.2-7.5-1.7-7.5-1.7-11 4.2-1.1 1.7-1.3 1.6-3.4-1.9-2.4-4.1-2.3-4.1-10.2-2.1z" />
    <path d="M55.5 47.5c-5.9 2.9-6 3.4-6.3 34.3l-.3 28.3 10.8-.3 10.8-.3V81.9c0-30.4-.2-31.6-6-34.4-4-1.9-5.2-1.9-9 0zm10.6 4.4c3.2 3.3 3.6 5.8 1.4 10-1.6 3.2-3.3 4.1-7.8 4.1-8.1-.1-11.4-10-5-15 3.7-2.9 7.9-2.6 11.4.9z" />
  </svg>
);
export default extendIcon(Deha25);
